/**
 * Typography stillerini döndürür
 * @param {Object} typography - Typography ayarları
 * @returns {Object} Typography stilleri
 */
export const getTypographyStyles = (typography = {}) => {
    const styles = {};
    
    if (typography.fontFamily) styles.fontFamily = typography.fontFamily;
    if (typography.fontSize) styles.fontSize = typography.fontSize;
    if (typography.fontWeight) styles.fontWeight = typography.fontWeight;
    if (typography.lineHeight) styles.lineHeight = typography.lineHeight;
    if (typography.letterSpacing) styles.letterSpacing = typography.letterSpacing;
    if (typography.textTransform) styles.textTransform = typography.textTransform;
    if (typography.fontStyle) styles.fontStyle = typography.fontStyle;
    if (typography.textDecoration) styles.textDecoration = typography.textDecoration;
    if (typography.color) styles.color = typography.color;
    if (typography.textAlign) styles.textAlign = typography.textAlign;
    
    return styles;
}; 